import React, { Fragment } from 'react';
import { string } from 'prop-types';

const countryFormatThousand = {
    FR: ' ',
    ES: '.',
    IT: '.',
    DE: '.',
    GB: ',',
};

// The regex forms groups of 3 chars, then a join() is used to place the thousand separator between those groups
const formatIntegerPrice = (integer, locale) =>
    integer
        .toString()
        .split(/(?=(?:...)*$)/g)
        .join(countryFormatThousand[locale]);

export default function FormattedPrice({ integer, decimal, locale, currency }) {
    if (locale.toLowerCase() !== 'gb') {
        return (
            <Fragment>
                <span className="price-integer">
                    {formatIntegerPrice(integer, locale)}
                </span>
                <span className="price-currency-decimal">
                    <span className="price-currency">{currency}</span>
                    <span className="price-decimal">{decimal}</span>
                </span>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <span>{currency}</span>
            <span className="price-integer">
                {formatIntegerPrice(integer, locale)}
            </span>
            .<span className="price-decimal">{decimal}</span>
        </Fragment>
    );
}

FormattedPrice.propTypes = {
    integer: string.isRequired,
    decimal: string.isRequired,
    locale: string.isRequired,
    currency: string.isRequired,
};
